import React from 'react';
import { SVGS } from '../../../assets/images';
import styles from './delete-icon-button.module.scss';

interface Props {
    onClick?: (row: any) => void;
}

export const DeleteIconButton = (props: Props) => {

    return (
        <button
            type='button'
            onClick={(e) => {
                e.stopPropagation();
                props.onClick && props.onClick(e);
            }}
            className={styles.deleteButton}>
            <SVGS.DeleteIcon />
        </button>
    );
};